import React from "react";
import * as R from "ramda";
import detailStyles from "Portal/NewPortal/Sections/Sessions/FlyOver/View/Details/styles.scss";
import { connect } from "react-redux";
import { getters } from "../model";
import * as PortalSelectors from "redux/modules/portal/selectors";
import { Div } from "components/Base";
import { WithFormInstanceProvider } from "ui-kit/Form/View";
import { EDIT_PARTICIPANT_FORM_ID } from "../constants";
import { getEventTimezone } from "redux/modules/event/selectors";
import { getEditableFields } from "../selectors";
import { Label } from "EventLight/Common/FieldLayout";
import InfoPanel from "./InfoPanel";

import useDisplay from "Portal/NewPortal/Shared/useDisplay";
import { resolveField } from "Portal/NewPortal/Sections/Profile/View/EventInfo/EventInfo";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(EDIT_PARTICIPANT_FORM_ID)),
  connect(
    state => ({
      portal: PortalSelectors.portal(state),
      timezone: getEventTimezone(state),
      fields: getEditableFields(state),
      values: getters.values(state),
      updatedFieldValues: getters.updatedFieldValues(state)
    }),
    {}
  )
);

const EditMode = ({ fields, values = {}, updatedFieldValues = {} }) => {
  const display = useDisplay();
  return (
    <div className={detailStyles.participantContainer}>
      <div className={detailStyles.innerContainer}>
        <InfoPanel />

        <Div display="column" style={{ gap: 16 }} width={1}>
          {fields.map(pairedFields => {
            return (
              <Div
                display={display}
                width={1}
                style={{
                  gap: 20
                }}
              >
                {pairedFields.map(field => {
                  return (
                    <Div display="column" width={1}>
                      <Label fs={2} color="neutral7">
                        {field.name}
                      </Label>
                      {resolveField({
                        field,
                        data: values,
                        updatedFieldValues,
                        disabled: field.is_locked
                      })}
                    </Div>
                  );
                })}
              </Div>
            );
          })}
        </Div>
      </div>
    </div>
  );
};

export default decorate(EditMode);
